
import { mapGetters } from 'vuex';

export default {
    props: {
        categories: { type: Array, required: true },
    },
    computed: {
        ...mapGetters('restaurants', ['currentCategory']),
        currentCategoryIndex() {
            return (
                this.currentCategory &&
                this.categories.findIndex(category => category.slug === this.currentCategory.slug)
            );
        },
        swiperSettings() {
            return {
                initialSlide: this.currentCategoryIndex || 0,
                slidesPerView: 'auto',
                slideToClickedSlide: true,
                // speed: 1000,
                cssMode: true,
                // loop: true,
                // spaceBetween: 8,
            };
        },
    },
};
